import { render } from "./otahouse.vue?vue&type=template&id=1a74b898&scoped=true"
import script from "./otahouse.vue?vue&type=script&lang=js"
export * from "./otahouse.vue?vue&type=script&lang=js"

import "./otahouse.vue?vue&type=style&index=0&id=1a74b898&lang=scss&scoped=true"
import "./otahouse.vue?vue&type=style&index=1&id=1a74b898&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a74b898"]])

export default __exports__